import React from 'react';
import {
    Bar,
    Title,
    BackIcon,
    RightIcon,
    TopBgImage,
    barColor,
} from './Topbar.style';

const Topbar = ({
    title,
    rightIcon = '',
    transparent = false,
    fillOnScroll = true,
    showLeftIcon = true,
    goBack,
}) => {

    window.addEventListener('scroll', () => {
        const bar = document.getElementById('top-bar');
        if (bar) {
            bar.style.background = (window.scrollY > 30 && fillOnScroll) ? barColor : transparent ? 'transparent' : barColor;
        }
    });

    return (
        <>
            <Bar id='top-bar' bg={transparent ? 'transparent' : 'filled'}>
                {showLeftIcon && <BackIcon onClick={() => goBack()} />}
                <Title>
                    {title}
                </Title>
                {rightIcon &&
                    <RightIcon>
                        {rightIcon}
                    </RightIcon>
                }
            </Bar>
            {transparent && <TopBgImage />}
        </>
    );
}

export default Topbar;